import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";

const FOOTER_NAV = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Accommodation", href: "/rooms" },
  { label: "Dining", href: "/dining" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/contact" },
];

const SOCIAL_LINKS = [
  {
    icon: Facebook,
    href: "https://www.facebook.com/metropoliskmr1/",
    label: "Facebook",
  },
  {
    icon: Instagram,
    href: "https://www.instagram.com/metropoliskmr/",
    label: "Instagram",
  },
];

export default function PublicFooter() {
  return (
    <footer className="bg-metro-green-950 text-white">
      <div className="mx-auto max-w-container px-6 py-16 md:px-8">
        <div className="flex flex-col items-center text-center">
          <nav className="mb-6 flex flex-wrap justify-center gap-8 text-sm opacity-85">
            {FOOTER_NAV.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="transition hover:opacity-100"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="mb-8 flex gap-5">
            {SOCIAL_LINKS.map(({ icon: Icon, href, label }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                className="transition hover:opacity-70"
              >
                <Icon size={18} />
              </a>
            ))}
          </div>

          <div className="mb-6 font-serif text-3xl tracking-[0.25em]">
            METROPOLIS
          </div>

          <div className="flex w-full flex-col items-center gap-3 border-t border-white/10 pt-6 text-xs opacity-70 md:flex-row md:justify-between">
            <span>© 2026 Hotel Metropolis, Srinagar. All Rights Reserved.</span>
            <div className="flex gap-5">
              <Link to="/terms" className="hover:opacity-100">
                Terms &amp; Conditions
              </Link>
              <Link to="/privacy" className="hover:opacity-100">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}